import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  /**
   * Downloads a file from a URL
   * @param url - The URL of the file to download
   * @param fileName - The name to use for the downloaded file
   */
  downloadFile(url: string, fileName: string): void {
    if (!url) {
      return;
    }

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const objectUrl = globalThis.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName || 'attachment';
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(objectUrl);
      })
      .catch(() => {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'attachment';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  }
}

